const routes = Object.freeze({
  home: '/',
  list: '/list',
  post: '/post',
});

export default routes;
